import React from 'react'
import { Form, Header, Icon, Menu, Accordion } from 'semantic-ui-react'
import Immutable from 'seamless-immutable'
import _ from 'lodash'

import firebase from '../../../../config/firebase'
import ChoiceForm from '../../forms/choiceForm'

const styles = {
  item: {
    padding: '13px 10px',
    borderRadius: 0
  },
  itemRow: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  itemName: {
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    lineHeight: '1.3',
    display: 'flex',
    flex: 1,
    fontSize: 15,
  },
}

class Preview extends React.PureComponent {
  state = {
    activeItemKey: null,
    activeOptionId: null,
    data: {},
  }

  componentDidMount() {
    const { selectedItemKeys, selectedItemOptionIds } = this.props
    this.populateData()

    this.setState({
      activeItemKey: selectedItemKeys[0],
      activeOptionId: selectedItemOptionIds[0],
    })
  }

  onChoiceChange = (choiceId, choice) => {
    const { activeItemKey, activeOptionId, data } = this.state
    const newData = data.setIn([activeItemKey, activeOptionId, 'choices', choiceId], choice)
    this.setState({ data: newData })
  }

  onChoiceRemove = choiceId => {
    const { activeItemKey, activeOptionId, data } = this.state

    const newData = data.updateIn(
                      [activeItemKey, activeOptionId, 'choices'],
                      choices => choices.without(choiceId)
                    )

    this.setState({ data: newData })
  }

  onDefaultChoiceChange = choiceId => {
    const { activeItemKey, activeOptionId, data } = this.state
    const newData = data.setIn([activeItemKey, activeOptionId, 'default_choice'], choiceId)

    this.setState({ data: newData })
  }

  save = async () => {
    const { data } = this.state
    const { storeId, items } = this.props

    const updates = {}

    _.forEach(data, (itemOptions, itemKey) => {
      let order = (_.max(_.map(items[itemKey].options, 'order')) || 0) + 1

      _.forEach(itemOptions, (itemOption, ioId) => {
        // eslint-disable-next-line camelcase
        const { default_choice } = itemOption

        const choices = _.reduce(itemOption.choices, (result, choice, choiceId) => {
          // eslint-disable-next-line no-param-reassign
          result[choiceId] = { price: choice.price, order: choice.order }
          return result
        }, {})

        updates[`items/${storeId}/${itemKey}/options/${ioId}`] = {
          order,
          choices,
          default_choice,
        }


        order += 1
      })
    })

    await firebase.database().ref().update(updates)
  }

  populateData = () => {
    const { selectedItemKeys, selectedItemOptionIds, itemOptions } = this.props
    const data = {}

    selectedItemKeys.forEach(itemKey => {
      const selectedItemOptions = {}

      selectedItemOptionIds.forEach(ioId => {
        selectedItemOptions[ioId] = itemOptions[ioId]
      })

      data[itemKey] = selectedItemOptions
    })

    this.setState({ data: Immutable(data) })
  }

  sortChoices = choices => {
    const choiceArray = _.map(choices, (choice, choiceId) => ({ ...choice, id: choiceId }))
    const sortedChoices = _.sortBy(choiceArray, choice => choice.order)

    return sortedChoices.reduce((result, { ...choice, id }) => {
      result[id] = choice

      return result
    }, {})
  }

  renderItemList = () => {
    const { activeItemKey } = this.state
    const { items, selectedItemKeys } = this.props

    return (
      <div>
        <Header>List of Items</Header>
        <div className="item-preview-tab">
          <div>
            <Menu pointing vertical>
              {
                selectedItemKeys.map(itemKey => (
                  <Menu.Item
                    key={itemKey}
                    active={itemKey === activeItemKey}
                    style={styles.item}
                    onClick={() => this.setState({ activeItemKey: itemKey })}
                  >
                    <div style={styles.itemRow} >
                      <div style={styles.itemName}>
                        {items[itemKey] && items[itemKey].name}
                      </div>
                    </div>
                  </Menu.Item>
                ))
              }
            </Menu>
            </div>
        </div>
      </div>
    )
  }

  renderOptionPreview = () => {
    const { activeOptionId, activeItemKey, data } = this.state
    const itemOptions = data[activeItemKey]

    return (
      <div style={{ marginLeft: 20, flex: 1 }}>
        <Header as='h3' style={{ marginBottom: 15 }}>
          List of Item Options
        </Header>
        <Form>
          <Accordion styled fluid>
            {
              _.map(itemOptions, (itemOption, ioId) => (
                <React.Fragment key={ioId}>
                  <Accordion.Title
                    active={activeOptionId === ioId}
                    index={ioId}
                    onClick={() => this.setState({ activeOptionId: activeOptionId === ioId ? null : ioId })}
                  >
                    <Icon name='dropdown' />
                    { itemOption.name }
                  </Accordion.Title>
                  <Accordion.Content active={activeOptionId === ioId}>
                    {
                      _.map(this.sortChoices(itemOption.choices), (choice, choiceKey) => (
                        <ChoiceForm
                          disableNameEditing
                          key={choiceKey}
                          isDefault={choiceKey === itemOption.default_choice}
                          choice={choice}
                          onChange={nextChoice => this.onChoiceChange(choiceKey, nextChoice)}
                          onRemove={() => this.onChoiceRemove(choiceKey)}
                          onDefaultChange={() => this.onDefaultChoiceChange(choiceKey)}
                        />
                      ))
                    }
                  </Accordion.Content>
                </React.Fragment>
              ))
            }
          </Accordion>
        </Form>
      </div>
    )
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {this.renderItemList()}
        {this.renderOptionPreview()}
      </div>
    )
  }
}

export default Preview



// WEBPACK FOOTER //
// ./src/components/restaurants/views/itemOptionLinker/preview.js